import styles from './styles.module.scss';

import cn from 'classnames';
import { useState } from 'react';
import TooltipBase from './Base';


const Tooltip = ({ text = '', position = 'bottom', style, className, isShow = true, children, ...props }) => {
  const [isHover, changeHover] = useState(false);

  return (
    <div
      className={cn(styles.tooltip_block, className)}
      onMouseOver={() => changeHover(true)}
      onMouseLeave={() => changeHover(false)}
      {...props}
    >
      {children}
      {isHover && isShow && <TooltipBase text={text} {...{ text, position, style }} />}
    </div>
  );
};

export default Tooltip;
